<dm-breadcrumb
  itemstyle="text"
  separator="chevron"
  navLabel="Navigationspfad"
  i18n-navLabel="@@common.breadcrumb"
  [rootless]="true"
  [lines]="false"
>
  @for (crumb of crumbs(); track $index) {
    <dm-breadcrumb-item [current]="crumb.url === undefined">
      @if (crumb.url === undefined) {
        {{ crumb.label }}
      } @else {
        <a [routerLink]="crumb.url">{{ crumb.label }}</a>
      }
    </dm-breadcrumb-item>
  }
</dm-breadcrumb>
